import * as z from "zod";

/**
 * Finds customer returns headed to (or already delivered but not yet processed
 * at) the location a problem order is being picked from, whose returned
 * variants match the order's still-needed items. Surfaces returned inventory a
 * picker could use to solve the order.
 */
export const getPossibleReturnsForProblemOrder = {
  name: "getPossibleReturnsForProblemOrder" as const,
  input: z.object({
    crdbLocationId: z.string().nullish(),
    merchantTeamId: z.string().nullish(),
    items: z.array(
      z.object({ variantId: z.string().nullish(), sku: z.string().nullish() }),
    ),
  }),
  output: z.object({
    returnsCenterResolved: z.boolean(),
    returns: z.array(
      z.object({
        returnId: z.string(),
        // "open" (approved, not yet shipped), "in_transit" (incoming), or
        // "delivered" (arrived, awaiting processing).
        returnStatus: z.string(),
        createdAt: z.string().nullish(),
      }),
    ),
  }),
};
